var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ICellEditorParams } from 'ag-grid-community';
import { DwAgGridValidationEditorComponent } from './ag-grid-validation-editor';
var DwAgTextCellEditorComponent = /** @class */ (function (_super) {
    __extends(DwAgTextCellEditorComponent, _super);
    function DwAgTextCellEditorComponent(fb) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        return _this;
    }
    // Gets called once after GUI is attached to DOM.
    // Useful if you want to focus or highlight a component
    // (this is not possible when the element is not attached)
    DwAgTextCellEditorComponent.prototype.afterGuiAttached = function () {
        if (this.cellInput && !this.isFullRowEdit()) {
            this.cellInput.nativeElement.focus();
            this.cellInput.nativeElement.select();
        }
    };
    // gets called once after the editor is created
    DwAgTextCellEditorComponent.prototype.agInit = function (params) {
        this.editType = params.api.gridOptionsWrapper.gridOptions.editType || '';
        this.columnId = params.column.colId;
        this.formControl = new FormControl(params.value, params.validators);
        this.validateForm = params.form;
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.validateForm.addControl(this.columnId, this.formControl);
        this.formControl.markAsDirty();
        _super.prototype.init.call(this);
    };
    // If doing full row edit, then gets called when tabbing into the cell.
    DwAgTextCellEditorComponent.prototype.focusIn = function () {
    };
    // If doing full row edit, then gets called when tabbing out of the cell.
    DwAgTextCellEditorComponent.prototype.focusOut = function () {
    };
    // Should return the final value to the grid, the result of the editing
    DwAgTextCellEditorComponent.prototype.getValue = function () {
        return this.formControl.value;
    };
    // Gets called once before editing starts, to give editor a chance to
    // cancel the editing before it even starts.
    DwAgTextCellEditorComponent.prototype.isCancelBeforeStart = function () {
        return false;
    };
    // Gets called once when editing is finished (eg if enter is pressed).
    // If you return true, then the result of the edit will be ignored.
    DwAgTextCellEditorComponent.prototype.isCancelAfterEnd = function () {
        return this.validationMessages.length > 0;
    };
    // Gets called once after initialised.
    // If you return true, the editor will appear in a popup
    DwAgTextCellEditorComponent.prototype.isPopup = function () {
        return false;
    };
    DwAgTextCellEditorComponent.prototype.ngOnDestroy = function () {
        this.validateForm.removeControl(this.columnId);
    };
    return DwAgTextCellEditorComponent;
}(DwAgGridValidationEditorComponent));
export { DwAgTextCellEditorComponent };
